/* @ngInject */
function selectMaterialCollectionService () {
  const service = {
    unselectAllExceptFirstSelected,
    handleShiftClickOnMaterial,
    handleShiftClickOnCollection,
    handleNavigateThroughKeyboard,
    getDisabledTemplatesRule
  }

  return service

  function removeDisabledTemplates (templates, disabledTemplatesRule) {
    if (disabledTemplatesRule === 'CUSTOMIZABLE') {
      return templates.filter(t => !t.isCustomizable || t.customizationLevel === 'ONLY_DOWNLOAD')
    } else if (!disabledTemplatesRule && templates.length) {
      const firstTemplate = templates[0]
      const customizableTemplate = firstTemplate.isCustomizable && firstTemplate.customizationLevel !== 'ONLY_DOWNLOAD'

      if (customizableTemplate) {
        return [firstTemplate]
      } else {
        return templates.filter(t => !t.isCustomizable || t.customizationLevel === 'ONLY_DOWNLOAD')
      }
    }

    return templates
  }

  function unselectLastItemFromSelectedItems (selectedItems, scope) {
    let lastItem = null
    lastItem = selectedItems.pop()
    lastItem.selected = false

    scope.$apply()
  }

  function addNewItemToSelectedItems (newSelectedItem, selectedItems, scope, disabledTemplatesRule) {
    if (disabledTemplatesRule === 'ALL') return
    if (disabledTemplatesRule === 'CUSTOMIZABLE' && newSelectedItem.isCustomizable && newSelectedItem.customizationLevel !== 'ONLY_DOWNLOAD') return

    newSelectedItem.selected = true
    selectedItems.push(newSelectedItem)
    scope.$apply()
  }

  function unselectAllAndSelectNewItem (newSelectedItem, params) {
    const { selectedTemplates, selectedCollections, scope, type } = params

    selectedTemplates.forEach(template => {
      template.firstSelection = false
      template.selected = false
    })

    selectedCollections.forEach(collection => {
      collection.firstSelection = false
      collection.selected = false
    })

    selectedTemplates.length = 0
    selectedCollections.length = 0

    newSelectedItem.selected = true
    newSelectedItem.firstSelection = true

    if (type === 'template') {
      selectedTemplates.push(newSelectedItem)
    } else if (type === 'collection') {
      selectedCollections.push(newSelectedItem)
    }
    scope.$apply()
  }

  function handleNavigateShiftPressed (params) {
    const {
      selectedTemplates,
      selectedCollections,
      isArrowLeft,
      isArrowRight,
      hasSelectedTemplate,
      hasSelectedCollection,
      templatesCount,
      collectionsCount,
      currentSelectedTemplateIndex,
      currentSelectedCollectionIndex,
      sectionTemplates,
      sectionCollections,
      scope,
      disabledTemplatesRule
    } = params

    let lastSelectionDirection = ''

    if (selectedTemplates.length > 1) {
      const lastIndex = sectionTemplates.findIndex(template => template.id === selectedTemplates[selectedTemplates.length - 1].id)
      const secondLastIndex = sectionTemplates.findIndex(template => template.id === selectedTemplates[selectedTemplates.length - 2].id)

      if (lastIndex > secondLastIndex) {
        lastSelectionDirection = 'right'
      } else if (lastIndex < secondLastIndex) {
        lastSelectionDirection = 'left'
      }
    } else if (selectedCollections.length > 1) {
      const lastIndex = sectionCollections.findIndex(collection => collection.id === selectedCollections[selectedCollections.length - 1].id)
      const secondLastIndex = sectionCollections.findIndex(collection => collection.id === selectedCollections[selectedCollections.length - 2].id)

      if (lastIndex > secondLastIndex) {
        lastSelectionDirection = 'right'
      } else if (lastIndex < secondLastIndex) {
        lastSelectionDirection = 'left'
      }
    }

    if (lastSelectionDirection === 'left' && isArrowRight) {
      if (hasSelectedCollection && selectedCollections.length > 0) {
        unselectLastItemFromSelectedItems(selectedCollections, scope)
        return
      } else if (hasSelectedTemplate && selectedTemplates.length > 0) {
        unselectLastItemFromSelectedItems(selectedTemplates, scope)
        return
      }
    } else if (lastSelectionDirection === 'right' && isArrowLeft) {
      if (hasSelectedTemplate && selectedTemplates.length > 0) {
        unselectLastItemFromSelectedItems(selectedTemplates, scope)
        return
      } else if (hasSelectedCollection && selectedCollections.length > 0) {
        unselectLastItemFromSelectedItems(selectedCollections, scope)
        return
      }
    }

    // Specific case for when there is only one template selected and multiple collections selected
    // The opposite case also occurs, which is why this specific validation is needed

    if (selectedTemplates.length === 1 && selectedCollections.length > 0 && (lastSelectionDirection === '' || lastSelectionDirection === null) && isArrowLeft && !selectedTemplates[0].firstSelection) {
      unselectLastItemFromSelectedItems(selectedTemplates, scope)
    }

    if (selectedCollections.length === 1 && selectedTemplates.length > 0 && (lastSelectionDirection === '' || lastSelectionDirection === null) && isArrowRight && !selectedCollections[0].firstSelection) {
      unselectLastItemFromSelectedItems(selectedCollections, scope)
    }

    if (isArrowLeft) {
      if (hasSelectedTemplate && currentSelectedTemplateIndex > 0) {
        const previousTemplate = sectionTemplates[currentSelectedTemplateIndex - 1]
        addNewItemToSelectedItems(previousTemplate, selectedTemplates, scope, disabledTemplatesRule)
      } else if (hasSelectedTemplate && currentSelectedTemplateIndex === 0 && collectionsCount > 0 && currentSelectedCollectionIndex === -1) {
        const lastCollection = sectionCollections[collectionsCount - 1]
        addNewItemToSelectedItems(lastCollection, selectedCollections, scope, disabledTemplatesRule)
      } else if (hasSelectedCollection && currentSelectedCollectionIndex > 0) {
        const previousCollection = sectionCollections[currentSelectedCollectionIndex - 1]
        addNewItemToSelectedItems(previousCollection, selectedCollections, scope, disabledTemplatesRule)
      }
    } else if (isArrowRight) {
      if (hasSelectedTemplate && currentSelectedTemplateIndex < templatesCount - 1) {
        const nextTemplate = sectionTemplates[currentSelectedTemplateIndex + 1]
        addNewItemToSelectedItems(nextTemplate, selectedTemplates, scope, disabledTemplatesRule)
      } else if (hasSelectedCollection && currentSelectedCollectionIndex < collectionsCount - 1) {
        const nextCollection = sectionCollections[currentSelectedCollectionIndex + 1]
        addNewItemToSelectedItems(nextCollection, selectedCollections, scope, disabledTemplatesRule)
      } else if (hasSelectedCollection && currentSelectedCollectionIndex === collectionsCount - 1 && templatesCount > 0 && currentSelectedTemplateIndex === -1) {
        const firstTemplate = sectionTemplates[0]
        addNewItemToSelectedItems(firstTemplate, selectedTemplates, scope, disabledTemplatesRule)
      }
    }
  }

  function handleNavigateArrowsPressed (params) {
    const {
      selectedTemplates,
      selectedCollections,
      isArrowLeft,
      isArrowRight,
      hasSelectedTemplate,
      hasSelectedCollection,
      templatesCount,
      collectionsCount,
      currentSelectedTemplateIndex,
      currentSelectedCollectionIndex,
      sectionTemplates,
      sectionCollections,
      scope
    } = params

    if (isArrowLeft) {
      if (hasSelectedTemplate && currentSelectedTemplateIndex > 0) {
        const previousTemplate = sectionTemplates[currentSelectedTemplateIndex - 1]
        unselectAllAndSelectNewItem(previousTemplate, {
          type: 'template',
          selectedTemplates,
          selectedCollections,
          scope
        })
      } else if (hasSelectedTemplate && currentSelectedTemplateIndex === 0 && collectionsCount > 0) {
        const lastCollection = sectionCollections[collectionsCount - 1]
        unselectAllAndSelectNewItem(lastCollection, {
          type: 'collection',
          selectedTemplates,
          selectedCollections,
          scope
        })
      } else if (hasSelectedCollection && currentSelectedCollectionIndex > 0) {
        const previousCollection = sectionCollections[currentSelectedCollectionIndex - 1]
        unselectAllAndSelectNewItem(previousCollection, {
          type: 'collection',
          selectedTemplates,
          selectedCollections,
          scope
        })
      }
    } else if (isArrowRight) {
      if (hasSelectedTemplate && currentSelectedTemplateIndex < templatesCount - 1) {
        const nextTemplate = sectionTemplates[currentSelectedTemplateIndex + 1]
        unselectAllAndSelectNewItem(nextTemplate, {
          type: 'template',
          selectedTemplates,
          selectedCollections,
          scope
        })
      } else if (hasSelectedCollection && currentSelectedCollectionIndex < collectionsCount - 1) {
        const nextCollection = sectionCollections[currentSelectedCollectionIndex + 1]
        unselectAllAndSelectNewItem(nextCollection, {
          type: 'collection',
          selectedTemplates,
          selectedCollections,
          scope
        })
      } else if (hasSelectedCollection && currentSelectedCollectionIndex === collectionsCount - 1 && templatesCount > 0) {
        const firstTemplate = sectionTemplates[0]
        unselectAllAndSelectNewItem(firstTemplate, {
          type: 'template',
          selectedTemplates,
          selectedCollections,
          scope
        })
      }
    }
  }

  function unselectAllExceptFirstSelected (selectedTemplates, selectedCollections) {
    const firstSelectedTemplate = selectedTemplates.find(t => t.firstSelection)
    const firstSelectedCollection = selectedCollections.find(c => c.firstSelection)

    if (!firstSelectedTemplate && !firstSelectedCollection) {
      return
    }

    selectedTemplates.concat(selectedCollections).forEach(item => {
      item.selected = false
      item.firstSelection = false
    })

    if (firstSelectedTemplate) {
      firstSelectedTemplate.selected = true
      firstSelectedTemplate.firstSelection = true
      selectedTemplates.length = 0
      selectedTemplates.push(firstSelectedTemplate)
      selectedCollections.length = 0
    } else {
      firstSelectedCollection.selected = true
      firstSelectedCollection.firstSelection = true
      selectedTemplates.length = 0
      selectedCollections.length = 0
      selectedCollections.push(firstSelectedCollection)
    }
  }

  function getSectionTemplatesAndCollections (params) {
    const { sections, collection, sectionId } = params

    let sectionTemplates = []
    let sectionCollections = []

    if (sectionId && sections) {
      const section = sections.find(s => s.id === sectionId)
      if (section) {
        sectionTemplates = section.templates?.results || section.templates || []
        sectionCollections = section.collections?.results || section.collections || []
      }
    } else if (collection) {
      sectionTemplates = collection.templates?.results || collection.templates || []
      sectionCollections = collection.collections?.results || collection.collections || []
    }

    return {
      sectionTemplates,
      sectionCollections
    }
  }

  function handleShiftClickOnMaterial (material, params) {
    let { selectedTemplates, selectedCollections, sections, collection, disabledTemplatesRule } = params
    document.getSelection().removeAllRanges()
    unselectAllExceptFirstSelected(selectedTemplates, selectedCollections)

    const firstSelectedTemplate = selectedTemplates.find(t => t.firstSelection)
    const firstSelectedCollection = selectedCollections.find(c => c.firstSelection)

    const sectionId = firstSelectedTemplate?.artCollectionId || firstSelectedCollection?.parentId

    const { sectionTemplates, sectionCollections } = getSectionTemplatesAndCollections({
      sections,
      collection,
      sectionId
    })

    const indexOfClickedTemplate = sectionTemplates.indexOf(material)

    if (firstSelectedTemplate) {
      const indexOfFirstSelectedTemplate = sectionTemplates.indexOf(firstSelectedTemplate)
      const startIndex = Math.min(indexOfFirstSelectedTemplate, indexOfClickedTemplate)
      const endIndex = Math.max(indexOfFirstSelectedTemplate, indexOfClickedTemplate) + 1
      const templatesToSelect = sectionTemplates.slice(startIndex, endIndex)
      let filteredTemplates = [...templatesToSelect]
      if (disabledTemplatesRule !== 'IGNORE') {
        filteredTemplates = removeDisabledTemplates(templatesToSelect, disabledTemplatesRule)
      }

      filteredTemplates.forEach(t => {
        t.selected = true
      })
      selectedTemplates = [...filteredTemplates]
    } else if (firstSelectedCollection) {
      const indexOfFirstSelectedCollection = sectionCollections.indexOf(firstSelectedCollection)
      const collectionsToSelect = sectionCollections.slice(indexOfFirstSelectedCollection, (sectionCollections.length))
      const templatesToSelect = sectionTemplates.slice(0, indexOfClickedTemplate + 1)
      const filteredTemplates = removeDisabledTemplates(templatesToSelect, disabledTemplatesRule)

      collectionsToSelect.forEach(c => {
        c.selected = true
      })
      filteredTemplates.forEach(t => {
        t.selected = true
      })

      selectedCollections = [...collectionsToSelect]
      selectedTemplates = [...filteredTemplates]
    }

    return {
      selectedCollections,
      selectedTemplates
    }
  }

  function handleShiftClickOnCollection (collection, params) {
    let { selectedTemplates, selectedCollections, sections, section, disabledTemplatesRule } = params
    document.getSelection().removeAllRanges()
    unselectAllExceptFirstSelected(selectedTemplates, selectedCollections)

    const firstSelectedTemplate = selectedTemplates.find(t => t.firstSelection)
    const firstSelectedCollection = selectedCollections.find(c => c.firstSelection)

    const sectionId = firstSelectedTemplate?.artCollectionId || firstSelectedCollection?.parentId

    const { sectionTemplates, sectionCollections } = getSectionTemplatesAndCollections({
      sections,
      collection: section,
      sectionId
    })

    const indexOfClickedCollection = sectionCollections.indexOf(collection)

    if (firstSelectedCollection) {
      const indexOfFirstSelectedCollection = sectionCollections.indexOf(firstSelectedCollection)
      const startIndex = Math.min(indexOfFirstSelectedCollection, indexOfClickedCollection)
      const endIndex = Math.max(indexOfFirstSelectedCollection, indexOfClickedCollection) + 1
      const collectionsToSelect = sectionCollections.slice(startIndex, endIndex)

      collectionsToSelect.forEach(c => {
        c.selected = true
      })
      selectedCollections = [...collectionsToSelect]
    } else if (firstSelectedTemplate) {
      const indexOfFirstSelectedTemplate = sectionTemplates.indexOf(firstSelectedTemplate)
      const templatesToSelect = sectionTemplates.slice(0, indexOfFirstSelectedTemplate + 1)
      const filteredTemplates = removeDisabledTemplates(templatesToSelect, disabledTemplatesRule)
      const collectionsToSelect = sectionCollections.slice(indexOfClickedCollection, (sectionCollections.length))

      collectionsToSelect.forEach(c => {
        c.selected = true
      })
      filteredTemplates.forEach(t => {
        t.selected = true
      })

      selectedCollections = [...collectionsToSelect]
      selectedTemplates = [...filteredTemplates]
    }

    return {
      selectedCollections,
      selectedTemplates
    }
  }

  function handleNavigateThroughKeyboard (ev, params) {
    const { selectedTemplates, selectedCollections, sections, collection, scope, disabledTemplatesRule } = params
    const isArrowLeft = ev.code === 'ArrowLeft'
    const isArrowRight = ev.code === 'ArrowRight'
    const isShiftPressed = ev.shiftKey === true

    const hasSelectedTemplate = selectedTemplates.length > 0
    const hasSelectedCollection = selectedCollections.length > 0

    let sectionId = null
    if (hasSelectedTemplate) {
      sectionId = selectedTemplates[selectedTemplates.length - 1].artCollectionId
    } else if (hasSelectedCollection) {
      sectionId = selectedCollections[selectedCollections.length - 1].parentId
    }

    const { sectionTemplates, sectionCollections } = getSectionTemplatesAndCollections({
      sections,
      collection,
      sectionId
    })

    const templatesCount = sectionTemplates.length
    const collectionsCount = sectionCollections.length
    const currentSelectedTemplateIndex = hasSelectedTemplate ? sectionTemplates.findIndex((template) => template.id === selectedTemplates[selectedTemplates.length - 1].id) : -1
    const currentSelectedCollectionIndex = hasSelectedCollection ? sectionCollections.findIndex((collection) => collection.id === selectedCollections[selectedCollections.length - 1].id) : -1

    if (isShiftPressed) {
      handleNavigateShiftPressed({
        ...params,
        isArrowLeft,
        isArrowRight,
        hasSelectedTemplate,
        hasSelectedCollection,
        templatesCount,
        collectionsCount,
        currentSelectedTemplateIndex,
        currentSelectedCollectionIndex,
        sectionTemplates,
        sectionCollections,
        scope,
        disabledTemplatesRule
      })
    } else {
      handleNavigateArrowsPressed({
        ...params,
        isArrowLeft,
        isArrowRight,
        hasSelectedTemplate,
        hasSelectedCollection,
        sectionId,
        templatesCount,
        collectionsCount,
        currentSelectedTemplateIndex,
        currentSelectedCollectionIndex,
        sectionTemplates,
        sectionCollections,
        scope
      })
    }
  }

  function getDisabledTemplatesRule (selectedTemplates) {
    let disabledTemplatesRule = null
    if (!selectedTemplates.length) {
      return disabledTemplatesRule
    }

    const customizableTemplates = selectedTemplates.every(template => template.isCustomizable && template.customizationLevel !== 'ONLY_DOWNLOAD')
    disabledTemplatesRule = customizableTemplates ? 'ALL' : 'CUSTOMIZABLE'

    return disabledTemplatesRule
  }
}

export { selectMaterialCollectionService }
